import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  content: {
    position: "relative",
    width: "100%",
    display: "flex",
    flexDirection: "column",

    [theme.breakpoints.up("md")]: {
      height: "100vh",
      overflowY: "scroll",
    },
  },
  stickyCompactSummary: {
    position: "fixed",
    top: 50,
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: "white",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    animation: "slideDown 0.3s ease-out",
    "@keyframes slideDown": {
      from: {
        transform: "translateY(-100%)",
      },
      to: {
        transform: "translateY(0)",
      },
    },
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(2),
    maxWidth: 605,
    margin: "0 auto",
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
    },
  },
  title: {
    fontSize: "1.5rem",
    textWrap: "balance",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.875rem",
      textAlign: "left",
      maxWidth: "90%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  createdByContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: theme.spacing(12),
    gap: theme.spacing(2),
  },
  userDetails: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(4),
  },
  followButton: {
    fontSize: "12px",
    width: "60px",
    height: "20px",
  },
  createdByText: {
    fontWeight: 700,
  },
  generationsContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(8),
    maxWidth: 605,
    margin: "0 auto",
    width: "100%",
    paddingBottom: theme.spacing(20),

    [theme.breakpoints.down("md")]: {
      paddingBottom: theme.spacing(4),
    },
  },
  generations: {
    maxWidth: 605,
    margin: "0 auto",
    width: "100%",
  },
}));
